const MONITOR_API = {
  GetFilletImages: "/filletImages",
  GetFilletDetails: "/filletDetails",
  GetColorGradingRatio: "/colorGradingRatio",
  getMonitorBatches: "/Monitor/Batches",
  getMonitorImages: "/Monitor/ProcessedProductImage",
  getFilletInfo: "/Monitor/FilletInfo",
  getStatisticsbyBatch: "/Statistics/Fillet",
  getLiveMonitorImages: "/Monitor/PIDImage",
  getMonitorAverage: "/Monitor/ProcessedProductAverages",
  getMonitorAverageAll: "/Monitor/ProcessedProductAverages-All",
  getFilletInfoByPID: "/Monitor/PIDImage",
  getFilletInfoByDate: "/Monitor/ProcessedProductByDate",
};

export default MONITOR_API;
